import type { RootState } from '../types';
import { getPrefixOffset } from './config';

export const isCallDetectorInitialized = (state: RootState) => state.backend.call.isInitialized;

export const isCallHolded = (state: RootState) => state.backend.call.isOnHold;

export const isCallStarted = (state: RootState) => state.backend.call.isStarted;

export const getSessionDurationMsec = (state: RootState) => state.backend.call.sessionDurationMsec;

export const getSessionStartOffsetMsec = (state: RootState) => state.backend.call.sessionStartOffsetMsec;

export const getSessionEndOffsetMsec = (state: RootState) => state.backend.call.sessionEndOffsetMsec;

export const callDetectionOffset = (state: RootState) => getSessionDurationMsec(state) - getSessionStartOffsetMsec(state);

export function getCallId(state: RootState) {
    return state.backend.call.id;
}

export function getLastCallId(state: RootState) {
    return state.backend.call.lastCallId;
}

export function getMetaCallId(state: RootState) {
    return state.backend.call.metaCallID;
}

export function getCallDetectionSessionId(state: RootState) {
    return state.backend.call.sessionId;
}

export function isReloading(state: RootState) {
    return state.backend.common.isReloading;
}

export function isImmediate(state: RootState) {
    return state.backend.common.isImmediate;
}

export function shouldNotifyUiAboutReload(state: RootState) {
    return !isImmediate(state) && isReloading(state);
}

export function isCountDownOver(state: RootState) {
    return (state.backend.common.countdown || 0) === 0;
}

export function getCountDown(state: RootState) {
    return state.backend.common.countdown || 0;
}

export function isReadyToReload(state: RootState) {
    return isReloading(state) && isCountDownOver(state);
}

export function getUnfinishedCallDurationMsec(state: RootState) {
    return getSessionDurationMsec(state) - getSessionStartOffsetMsec(state);
}

export function getCallDurationMsec(state: RootState) {
    const prefixOffset = Number(getPrefixOffset(state) || 0);
    return getSessionEndOffsetMsec(state) - getSessionStartOffsetMsec(state) + prefixOffset;
}

export function getCallMode(state: RootState) {
    return state.backend.call.callMode ?? null;
}

export function getIsTrainerActive(state: RootState) {
    return state.backend.main.isTrainerActive ?? true;
}

export function getRemoveCall(state: RootState) {
    return state.backend.call.removeCall ?? false;
}

export function isMainConnectionOpen(state: RootState) {
    return state.backend.main.mainConnectionOpened ?? false;
}

export function isAudioSystemInfoConnectionOpen(state: RootState) {
    return state.backend.main.systemInfoConnectionOpened ?? false;
}
